import React from 'react';
import PropTypes from 'prop-types';
import { Alert, AlertTitle, Grid } from '@mui/material';

const AlertWidget = ({ onClose, alert }) => {
  return alert ? (
    <Grid item md={12} xs={12}>
      <Alert
        variant={alert.variant}
        severity={alert.severity ?? 'info'}
        onClose={onClose}
      >
        <AlertTitle>{alert.title}</AlertTitle>
        {alert.message}
      </Alert>
    </Grid>
  ) : null;
};

AlertWidget.propTypes = {
  alert: PropTypes.object.isRequired,
  onClose: PropTypes.func,
};

export default AlertWidget;
